import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { VisibleActionContext } from "./VisibleActionContext";
import { jsx as _jsx } from "react/jsx-runtime";
var VisibleActionProvider = function VisibleActionProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    currentAction = _useState2[0],
    setCurrentAction = _useState2[1];

  // Timeout to handle current action
  var actionTimeout = useRef();
  useEffect(function () {
    if (actionTimeout.current) {
      clearTimeout(actionTimeout.current);
    }
    // Clear action after half second
    if (currentAction) {
      actionTimeout.current = window.setTimeout(function () {
        setCurrentAction(undefined);
      }, 500);
    }
  }, [currentAction]);
  var changeCurrentAction = useCallback(function (action) {
    setCurrentAction(action);
  }, []);
  var contextValue = useMemo(function () {
    return {
      currentAction: currentAction,
      changeCurrentAction: changeCurrentAction
    };
  }, [currentAction, changeCurrentAction]);
  return /*#__PURE__*/_jsx(VisibleActionContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default VisibleActionProvider;